import * as React from 'react';
import { IListViewFieldColumn } from "../../../../../../services/ViewService";
import { Attachment } from '../../../../../../entities/Subentities';
import { formatBytes } from '../../../../../utils/common';

const FileSize = ({ entity }: IListViewFieldColumn<Attachment>) => <div>{getValue(entity)}</div> 

export const getValue = (entity: Attachment): string => entity.externalData?.FileSize
    ? formatBytes(entity.externalData?.FileSize)
    : "";

export default FileSize;